import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-special-instructions-dialog',
	templateUrl: './special-instructions-dialog.component.html',
	styleUrls: ['./special-instructions-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SpecialInstructionsDialogComponent implements OnInit {
	@Input() specialInstructions;
	@Input() layoutAlign;
	@Input() modalTitle: string = 'Special Instructions';
	@Input() isEditable: boolean = false;
	@Input() primaryButtonText: string = 'Done';
	@Input() secondaryButtonText: string = 'Cancel';
	@Input() displaySecondaryButton: boolean = false;

	@Output() updatedString = new EventEmitter<any>();

	constructor(public dialog: MatDialog, private utilService: UtilService) {}

	ngOnInit() {}

	openSpecialInstructionsDialog() {
		const dialogRef = this.dialog.open(SpecialInstructionsDialog, {
			width: '950px',
			data: {
				specialInstructions: this.specialInstructions,
				modalTitle: this.modalTitle,
				isEditable: this.isEditable,
				primaryButtonText: this.primaryButtonText,
				secondaryButtonText: this.secondaryButtonText,
				displaySecondaryButton: this.displaySecondaryButton,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				console.log('res: ', result);
				this.updatedString.emit(result);
			}
		});
	}
}

@Component({
	selector: 'app-special-instructions-dialog-modal',
	templateUrl: 'modal.template.html',
})
export class SpecialInstructionsDialog {
	constructor(
		public dialogRef: MatDialogRef<SpecialInstructionsDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	closeDialog(updatedString: string = null): void {
		this.dialogRef.close(updatedString);
	}
}
